export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10270.d729e3b6.jpg";